import { FormField } from '../types';

interface WizardValidationBannerProps {
  invalidFields: string[];
  fieldDefinitions: FormField[];
}

export function WizardValidationBanner({
  invalidFields,
  fieldDefinitions,
}: WizardValidationBannerProps) {
  if (invalidFields.length === 0) {
    return null;
  }

  const labelFor = (fieldName: string): string => {
    const field = fieldDefinitions.find((f) => f.name === fieldName);
    return field?.label ?? fieldName;
  };

  return (
    <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4" role="alert">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Please complete the required items below before continuing
          </h3>
          <ul className="mt-2 text-sm text-red-700 list-disc pl-5 space-y-1">
            {invalidFields.map((fieldName) => (
              <li key={fieldName}>{labelFor(fieldName)}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
